export enum PackageType {
	SelfServe = 'selfServe',	// user can purchase this package through the UI
	WeServe   = 'weServe',		// only Support can assign this package to an org or role
}

/**
 * List of all package things that can be charged for.
 */
export enum ChargeableProp {
	BaseFee          = 'baseFee',
	ChargePerLease   = 'chargePerLease',
	DebtReporting    = 'debtReporting',
	CreditChecks     = 'creditChecks',
	CreditChecksPro  = 'creditChecksPro',
	TenantSearch     = 'tenantSearch',
	BackgroundChecks = 'backgroundChecks',
}

/**
 * List of all package features.
 */
export enum PackageFeature {
	AutomaticReminders   = 'automaticReminders',
	RentReporting        = 'rentReporting',
	DebtReporting        = 'debtReporting',
	ReportToCollections  = 'reportToCollections',
	EmailSendCopy        = 'emailSendCopy',
	IntroEmail           = 'introEmail',
	CreditAlert          = 'creditAlert',
	CreditChecks         = 'creditChecks',
	CreditChecksPro      = 'creditChecksPro',
	TenantSearch         = 'tenantSearch',
	BackgroundChecks     = 'backgroundChecks',
	OrgImport            = 'orgImport',
	YardiImport          = 'yardiImport',
	YardiRoommatesImport = 'yardiRoommatesImport',
	ReportingThresholds  = 'reportingThresholds',
	ApplicantInvites     = 'applicantInvites',
	PreserveImportData   = 'preserveImportData', // keep the actual data from imports in testing, rather than scrambling it
	ManualPayments	     = 'manualPayments', // send invoices to customer for manual payment, rather than charging automatically
	LandlordAssist       = 'landlordAssist', // access to the landlord assist chatbot
}
